
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.LeaguesRegenerationSettings = View.LeaguesRegenerationSettings .extend({
		initialize: function() {
			this.scrollToTop()
				.getViewOptions()
				.initViewListeners()
				.fetchViewData();

			return this;
		},
		ui: {
			'form':              '#js-league-edit-form',
			'create_submit':     '#js-league-create',
			'combination_error': '#js-combination-error'
		},
		events: {
			'submit @ui.form':         'getFormData',
			'click @ui.create_submit': 'getFormData'
		},
		getViewOptions: function(){

			this.league_id = this.getOption('league_id');
			this.league    = this.getOption('league');
			this.rounds    = this.getOption('rounds');
			this.user      = this.getOption('user');

			return this;
		},
		initViewListeners: function(){

			this.listenTo(this.league, 'leagues:errors', this.showErrors);
			this.listenTo(this.league, 'leagues:create:success', this.leagueCreated);

			return this;
		},
		fetchViewData: function(){

			var complete = [
				this.league.show_regenerate().fetch({ data: { id: this.league_id } }),
				this.rounds.fetch({ cache: true, expires: 60 })
			];

			$.when.apply(null, complete).done(_.bind(this.initTemplate, this));

			return this;
		},

		initTemplate: function() {

			if (this.initData().isCanAccess()) {

				this.trigger('leagues:view:menu', this.league);
				return this.setForm().setModelData().render();
			}

			return this;
		},
		formChanged: function() {

			this.ui.create_submit.removeClass('disabled');
			return this;
		},
		setForm: function() {

			this.form = new Backbone.Form({template: this.form_template, model : this.league});

			this.form.render();

			this.form.fields.start_round.editor.setOptions(this.rounds.getRoundsOptions());
			// this.form.fields.privacy.editor.$el.closest('.field-set').toggleClass('disabled', true).find('input').prop('disabled', true);

			this.formChanged();

			return this;
		},
		getFormData: function() {
			this.showPreloader();
			$.jStorage.set('users_from_regenerated', [{id:this.league_id, users:this.league.get('users') ? this.league.get('users') : []}]);
			var form_data = _.extend(this.form.getValue(), {"regenerated_from": this.league_id});
			//console.log(form_data);
			this.league.create(form_data);

			return this;
		},
		leagueCreated: function(regenerated_league_id) {
			this.hidePreloader();
			this.trigger('leagues_regenerate:create', this.league_id, regenerated_league_id);

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));